/**
 * @generated SignedSource<<164de73d356e568210a8b3c97a16b505>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type RecentFilter = "ALL" | "COLLABORATED_ON" | "CREATED" | "WORKED_ON" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useRecentPreferencesUserPreferencesFragment$data = {
  readonly recentFilter: RecentFilter;
  readonly " $fragmentType": "useRecentPreferencesUserPreferencesFragment";
};
export type useRecentPreferencesUserPreferencesFragment$key = {
  readonly " $data"?: useRecentPreferencesUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentPreferencesUserPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useRecentPreferencesUserPreferencesFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recentFilter"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "2c1b5529f555004270b69bbda8b91b0d";

export default node;
